import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;
const token = process.env.REACT_APP_BACKEND_JWT_TOKEN;

export const refresh = (refreshToken, linkUuid) => {
  return axios.request({
    baseURL,
    url: '/v1/auth/refresh',
    method: 'POST',
    headers: {
      Authorization: token,
    },
    data: { refreshToken, linkUuid },
  });
};
